/* eslint-disable no-unused-vars */

// import ChargingSessionsAnalytics from './ChargingSessionsAnalytics';
// import SessionsList from '../../components/ChargingSessions/SessionsList';
import { useFetchCorporateByID } from '../../utils/queries/corporate';
import CorporateChargingSessionsList from '../../components/Corporates/CorporateChargingSessionsList';
import { Button, Typography, Tabs } from 'antd';
import { useQueryParam, StringParam, withDefault } from 'use-query-params';
import {
  Link,
  Switch,
  useRouteMatch,
  Route,
  Redirect,
  useHistory,
} from 'react-router-dom';
import { LeftOutlined } from '@ant-design/icons';
import { useState } from 'react';

const { TabPane } = Tabs;

const { Title } = Typography;

export default function CorporateChargingSessions({ corporateId = '' }) {
  const history = useHistory();
  const corporateData = {};
  // const {
  //   data: corporateData = {},
  //   isLoading,
  //   refetch,
  // } = useFetchCorporateByID(corporateId);
  const allFilters = [
    { name: 'All', key: 'all' },
    { name: 'Active Sessions', key: 'active' },
  ];

  // const [filter, setFilter] = useQueryParam(
  //   'filter',
  //   withDefault(StringParam, 'all'),
  // );
  const [filter, setFilter] = useState('all');
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div style={{ display: 'inline-flex', alignItems: 'center' }}>
          <LeftOutlined
            style={{ marginRight: '10px', cursor: 'pointer' }}
            onClick={() => history.goBack()}
          />
          <Title level={2} style={{ margin: '0px' }}>
            Charging Sessions
            <span style={{ color: '#2375b8', marginLeft: 5 }}>
              {corporateData?.data?.CORPORATE_NAME}
            </span>
          </Title>
        </div>
      </div>

      <Tabs
        activeKey={filter}
        onTabClick={(key) => {
          setFilter(key, 'push');
        }}
        className="w-full"
      >
        {allFilters.map(({ name, key }) => (
          <TabPane tab={name} key={key}>
            <CorporateChargingSessionsList
              filter={key}
              corporateId={corporateId}
            />
          </TabPane>
        ))}
        {/* <TabPane tab="Analytics" key="analytics">
          <div>ChargingSessionsAnalytics</div>
        </TabPane> */}
      </Tabs>
    </>
  );
}
